import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { ReactNode } from 'react';

export function ProtectedRoute({ children }: { children: ReactNode }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="app-loader">
                <div className="spinner" aria-hidden />
                <p>Chargement…</p>
            </div>
        );
    }

    if (!user) {
        // Redirige vers /login en mémorisant la destination voulue
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
}
